import React from 'react';
import Info from '../../../../../../src/assets/svg_main/info.svg';
import './PregnancyInfoBar.css'

interface PregnancyInfoBarProps {
    item: any;
}

const PregnancyInfoBar = ({ item }: PregnancyInfoBarProps) => {
  return (
    <div className="pregnancy-service-tooltip">
      <Info />
      <div className="facility-tooltip">
        <div>
          <label>Facility Type</label>
          <p>{item?.facility_type_name ? item?.facility_type_name : '-'}</p>
        </div>
        <div>
          <label>Facility Name</label>
          <p>{item?.facility_name ? item?.facility_name : '-'}</p>
        </div>
        <div>
          <label>Health Provider Name</label>
          <p>{`${item?.healthprovider_f_name ? item?.healthprovider_f_name + ' ' + (item?.healthprovider_l_name ? item?.healthprovider_l_name : '') : '-'}`}</p>
        </div>
        <div>
          <label>Asha name</label>
          <p>{`${item?.mobiliser_f_name ? item?.mobiliser_f_name + ' ' + item?.mobiliser_l_name : '-'}`}</p>
        </div>
      </div>
    </div>
  );
};

export default PregnancyInfoBar;
